import { createContext } from "react";

export const AmeaInfrastructureContext = createContext({ items: [] });
export const AmeaRoutesDataContext = createContext({ items: [] });
export const AmeaRoutesCategoriesContext = createContext({ items: [] });
export const AmeaInfrastructureFiltersContext = createContext({ items: [] });
export const AmeaDataContext = createContext({ items: [] });
export const EnvironmentalDataContext = createContext({ items: [] });
export const MeteoInfoDataContext = createContext({ items: [] });
export const WeatherDataContext = createContext({ items: [] });
export const IndexesDataContext = createContext({ items: [] });
export const AllSensorsDataContext = createContext({ items: [] });
export const SensorTypesDataContext = createContext({ items: [] });
export const NewRouteContext = createContext({ items: [] });
export const UserAuthContext = createContext({ items: [] });
